import { jsx as e } from "react/jsx-runtime";
import { Checkbox as s, Col as m } from "antd";
import { memo as f, useCallback as a } from "react";
import { u as o } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { useLanguageResolver as p } from "@biron-data/react-contexts";
const I = f(function({
  value: i,
  onChange: t
}) {
  const l = p(), c = a(
    (n) => {
      var r;
      t == null || t((r = n.target) == null ? void 0 : r.checked);
    },
    [t]
  );
  return /* @__PURE__ */ e(d, { span: 24, children: /* @__PURE__ */ e(
    s,
    {
      checked: i,
      onClick: c,
      children: /* @__PURE__ */ e(h, { children: l.get("configuration-invert-color") })
    }
  ) });
}), d = o(m)`
`, h = o.span`
  font-size: 12px;
  font-weight: 200;
  line-height: 15px;
  display: flex;
  align-items: center;
`;
export {
  I as default
};
//# sourceMappingURL=GrowthInvertSelector.js.map
